<div class="content-block history">
    <div class="title-with-options with-tabs bottom-line">
        <h2>History</h2>
    </div>
    <div class="content-pane no-padding">
        <!-- Templates -->

        <ng-template #billBalance let-bill let-align="align">
            <ng-container *ngIf="bill">
                {{ bill.due | currency }}
            </ng-container>
            <egov-text-ui-placeholder *ngIf="!bill" length="6"></egov-text-ui-placeholder>
        </ng-template>

        <ng-template #billDueDate let-bill let-align="align">
            <ng-container *ngIf="bill">
                {{ bill.dueDate | date }}
            </ng-container>
            <egov-text-ui-placeholder *ngIf="!bill" length="12"></egov-text-ui-placeholder>
        </ng-template>

        <ng-template #paymentPrintReceipt let-payment>
            <app-icon-button
                [disabled]="!payment.printUrl"
                [title]="getPaymentPrintReceiptTitle(payment)"
                (click)="paymentReceiptButtonClickHandler(payment, $event)"
            >
                receipt
            </app-icon-button>
        </ng-template>

        <ng-template #totalDue>
            <ng-container *ngIf="(totalAccountDue$ | async) !== undefined; else totalDuePlaceholder">
                {{ totalAccountDue$ | async | currency }}
            </ng-container>
            <ng-template #totalDuePlaceholder>
                <egov-text-ui-placeholder length="7"></egov-text-ui-placeholder>
            </ng-template>
        </ng-template>

        <!-- Templates over -->

        <p class="no-history" *ngIf="(historyBillsAndPayments$ | async) && !(historyBillsAndPayments$ | async)!.length; else results">
            This business doesn't have a history
        </p>
        <ng-template #results>
            <table *ngIf="!(viewport.tablet$ | async); else responsiveHistory" class="styled bills borderless wide">
                <thead>
                    <tr>
                        <th class="tax-year">
                            <div class="content">Year</div>
                        </th>
                        <th>
                            <div class="content">Owner</div>
                        </th>
                        <th class="numeric single-line">
                            <div class="content">Due</div>
                        </th>
                        <th class="numeric single-line">
                            <div class="content">Due Date</div>
                        </th>
                        <th *ngIf="displayReceiptId$ | async">
                            <div class="content">Receipt</div>
                        </th>
                        <th>
                            <div class="content">Payor</div>
                        </th>
                        <th class="single-line">
                            <div class="content">Paid On</div>
                        </th>
                        <th class="single-line">
                            <div class="content">Status</div>
                        </th>
                        <th class="numeric single-line">
                            <div class="content">Paid</div>
                        </th>
                        <th class="actions right single-line">
                            <div class="content screen-reader-text">Actions</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of (historyBillsAndPayments$ | async) || undefinedLists.get(5); trackBy: historyBillsAndPaymentsTrackBy">
                        <tr *ngIf="!item || isBill(item)">
                            <td class="tax-year">
                                <btax-tax-year [bill]="item"></btax-tax-year>
                            </td>
                            <td>
                                <btax-owner [bill]="item"></btax-owner>
                            </td>
                            <td class="numeric single-line">
                                <ng-container *ngTemplateOutlet="billBalance; context: { $implicit: item }"></ng-container>
                            </td>
                            <td class="right single-line">
                                <ng-container *ngTemplateOutlet="billDueDate; context: { $implicit: item }"></ng-container>
                            </td>
                            <ng-container *ngIf="!item || item?.payments?.length < 1">
                                <td *ngIf="displayReceiptId$ | async">
                                    <span class="unimportant-text">
                                        <ng-container *ngIf="item">-</ng-container>
                                        <egov-text-ui-placeholder *ngIf="!item" length="7"></egov-text-ui-placeholder>
                                    </span>
                                </td>
                                <td>
                                    <span class="unimportant-text">
                                        <ng-container *ngIf="item">-</ng-container>
                                        <egov-text-ui-placeholder *ngIf="!item" length="7"></egov-text-ui-placeholder>
                                    </span>
                                </td>
                                <td class="single-line">
                                    <span class="unimportant-text">
                                        <ng-container *ngIf="item">-</ng-container>
                                        <egov-text-ui-placeholder *ngIf="!item" length="7"></egov-text-ui-placeholder>
                                    </span>
                                </td>
                            </ng-container>
                            <ng-container *ngIf="item && item?.payments?.length === 1">
                                <td *ngIf="displayReceiptId$ | async">
                                    <span>
                                        <btax-receipt-number [payment]="item.payments[0]"></btax-receipt-number>
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        <btax-payor [payment]="item.payments[0]"></btax-payor>
                                    </span>
                                </td>
                                <td class="single-line">
                                    <span>
                                        <btax-paid-on [payment]="item.payments[0]"></btax-paid-on>
                                    </span>
                                </td>
                            </ng-container>
                            <ng-container *ngIf="item && item?.payments?.length > 1">
                                <td [attr.colspan]="(displayReceiptId$ | async) ? 3 : 2" class="expand single-line">
                                    <button mat-flat-button (click)="receiptsToggleHandler($event, item)">
                                        <span *ngIf="(billsWithPaymentsExpanded$ | async)?.has(item.id) === false"> Show payments </span>
                                        <span *ngIf="(billsWithPaymentsExpanded$ | async)?.has(item.id) !== false"> Hide payments </span>
                                        <mat-icon *ngIf="(billsWithPaymentsExpanded$ | async)?.has(item.id) === false" class="expand-icon">
                                            expand_more
                                        </mat-icon>
                                        <mat-icon *ngIf="(billsWithPaymentsExpanded$ | async)?.has(item.id) !== false" class="collapse-icon">
                                            expand_less
                                        </mat-icon>
                                    </button>
                                </td>
                            </ng-container>
                            <td class="single-line">
                                <btax-bill-status [bill]="item"></btax-bill-status>
                            </td>
                            <td class="numeric single-line">
                                <btax-bill-paid [bill]="item"></btax-bill-paid>
                            </td>
                            <td class="actions right align-middle single-line">
                                <div class="action-buttons">
                                    <app-icon-button
                                        [placeholder]="!item"
                                        [disabled]="shouldBillHaveItsReceiptButtonDisabled(item)"
                                        [title]="getPrintReceiptTitle(item)"
                                        (click)="billReceiptButtonClickHandler($event, item)"
                                    >
                                        receipt
                                    </app-icon-button>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="isPayment(item)" class="payment">
                            <td colspan="4"></td>
                            <td *ngIf="displayReceiptId$ | async">
                                <btax-receipt-number [payment]="item"></btax-receipt-number>
                            </td>
                            <td>
                                <btax-payor [payment]="item"></btax-payor>
                            </td>
                            <td class="single-line">
                                <btax-paid-on [payment]="item"></btax-paid-on>
                            </td>
                            <td class="single-line">
                                <btax-payment-status [payment]="item"></btax-payment-status>
                            </td>
                            <td class="numeric single-line">
                                <btax-payment-amount [payment]="item"></btax-payment-amount>
                            </td>
                            <td class="actions right align-middle single-line">
                                <div class="action-buttons">
                                    <ng-container *ngTemplateOutlet="paymentPrintReceipt; context: { $implicit: item }"></ng-container>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="1"></td>
                        <td class="right single-line unimportant-text"> Total Due </td>
                        <td class="numeric single-line">
                            <ng-container *ngTemplateOutlet="totalDue"></ng-container>
                        </td>
                        <td class="total-actions actions right single-line" [attr.colspan]="(displayReceiptId$ | async) ? 7 : 6">
                            <div class="option-buttons">
                                <div class="add-all" [class.remove]="accountInCart$ | async" [class.updating]="updatingAccountCartStatus$ | async">
                                    <button
                                        mat-button
                                        class="add-to-cart"
                                        [title]="addToOrRemoveFromCartTitle$ | async"
                                        (click)="toggleAccountInCart()"
                                        [disabled]="!(accountIsPayable$ | async)"
                                    >
                                        <span class="label text">Add all</span>
                                        <mat-icon class="right">
                                            <span class="actual-icon">add_shopping_cart</span>
                                            <app-action-button-spinner *ngIf="updatingAccountCartStatus$ | async"></app-action-button-spinner>
                                        </mat-icon>
                                    </button>
                                    <button
                                        mat-button
                                        class="remove-from-cart"
                                        [title]="addToOrRemoveFromCartTitle$ | async"
                                        (click)="toggleAccountInCart()"
                                        [disabled]="!(accountIsPayable$ | async)"
                                    >
                                        <span class="label text">Remove all</span>
                                        <mat-icon class="right">
                                            <span class="actual-icon">remove_shopping_cart</span>
                                            <app-action-button-spinner *ngIf="updatingAccountCartStatus$ | async"></app-action-button-spinner>
                                        </mat-icon>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>

            <!-- Responsive -->

            <ng-template #responsiveHistory>
                <app-show-more>
                    <table class="styled borderless narrow parcel-result-list">
                        <thead>
                            <tr>
                                <th class="tax-year">
                                    <div class="content">Year</div>
                                </th>
                                <th class="status">
                                    <div class="content">Status</div>
                                </th>
                                <th class="owner">
                                    <div class="content">Owner</div>
                                </th>
                                <th class="amount numeric">
                                    <div class="content">Due</div>
                                </th>
                                <th class="due-date numeric">
                                    <div class="content">Due Date</div>
                                </th>
                                <th class="actions right">
                                    <div class="content"></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let bill of (history$ | async) || undefinedLists.get(5); trackBy: historyTrackBy">
                                <tr class="bill" [class.showing-details]="((viewport.phone$ | async) || bill?.payments?.length) && showingDetails(bill)">
                                    <td class="tax-year data-field">
                                        <btax-tax-year [bill]="bill"></btax-tax-year>
                                    </td>
                                    <td class="status data-field">
                                        <div class="ellipsed">
                                            <div class="ellipsed-content" [class.loading]="!bill">
                                                <btax-bill-status [bill]="bill"></btax-bill-status>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="owner data-field">
                                        <div class="ellipsed">
                                            <div class="ellipsed-content" [class.loading]="!bill">
                                                <btax-owner [bill]="bill"></btax-owner>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="amount numeric data-field">
                                        <ng-container *ngTemplateOutlet="billBalance; context: { $implicit: bill }"></ng-container>
                                    </td>
                                    <td class="due-date numeric data-field">
                                        <ng-container *ngTemplateOutlet="billDueDate; context: { $implicit: bill }"></ng-container>
                                    </td>
                                    <td class="actions right align-middle">
                                        <div class="action-buttons" [style.margin-right]="'4px'">
                                            <ng-template #paymentBlockedTooltip>
                                                <div
                                                    style="min-width: 220px; max-width: 350px"
                                                    [innerHTML]="(blockMessages$ | async)?.paymentForbidden | MarkdownToHtml"
                                                ></div>
                                            </ng-template>
                                            <mat-menu #parcelDetailsMenu="matMenu" xPosition="before" overlapTrigger>
                                                <button
                                                    *ngIf="(viewport.phone$ | async) || bill?.payments?.length"
                                                    mat-menu-item
                                                    (click)="toggleDetailsForBill(bill)"
                                                >
                                                    {{ !showingDetails(bill) ? "Show details" : "Hide Details" }}
                                                </button>
                                                <mat-divider></mat-divider>
                                                <button
                                                    mat-menu-item
                                                    [disabled]="shouldBillHaveItsReceiptButtonDisabled(bill)"
                                                    (click)="billReceiptButtonClickHandler($event, bill)"
                                                >
                                                    Print Receipt
                                                </button>
                                            </mat-menu>
                                            <app-icon-button
                                                [placeholder]="!bill"
                                                [moreIconAtTheEnd]="true"
                                                [matMenuTriggerFor]="parcelDetailsMenu"
                                                (click)="$event.stopPropagation()"
                                            >
                                                more_vert
                                            </app-icon-button>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngIf="((viewport.phone$ | async) || bill?.payments?.length) && showingDetails(bill)" class="details">
                                    <td [attr.colspan]="!(viewport.phone$ | async) ? 5 : 4">
                                        <div class="owner">
                                            <h4 class="label">Owner</h4>
                                            <btax-owner [bill]="bill"></btax-owner>
                                        </div>
                                        <div class="due-date">
                                            <h4 class="label">Due Date</h4>
                                            <ng-container *ngTemplateOutlet="billDueDate; context: { $implicit: bill }"></ng-container>
                                        </div>
                                        <div class="payments" *ngIf="bill?.payments?.length">
                                            <h4>
                                                {{ bill.payments.length > 1 ? "Payments" : "Payment" }}
                                            </h4>
                                            <div class="payments-table-container">
                                                <table class="payments-table styled borderless" [class.showing-receipt-id]="!!(displayReceiptId$ | async)">
                                                    <thead class="tight">
                                                        <tr>
                                                            <th class="date">Paid On</th>
                                                            <th class="receipt" *ngIf="displayReceiptId$ | async">Receipt</th>
                                                            <th class="payor">Payor</th>
                                                            <th class="status">Status</th>
                                                            <th class="amount numeric">Amount</th>
                                                            <th class="actions right"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let payment of bill.payments" class="payment">
                                                            <td class="date">
                                                                <btax-paid-on [payment]="payment"></btax-paid-on>
                                                            </td>
                                                            <td class="receipt" *ngIf="displayReceiptId$ | async">
                                                                <ng-template #receiptTemplate
                                                                    ><btax-receipt-number [payment]="payment"></btax-receipt-number
                                                                ></ng-template>
                                                                <div class="ellipsed" *ngIf="viewport.phone$ | async; else receiptTemplate">
                                                                    <div class="ellipsed-content" [class.loading]="!bill">
                                                                        <ng-container *ngTemplateOutlet="receiptTemplate"></ng-container>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td class="payor">
                                                                <div class="ellipsed">
                                                                    <div class="ellipsed-content" [class.loading]="!bill">
                                                                        <btax-payor [payment]="payment"></btax-payor>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td class="status">
                                                                <div class="ellipsed">
                                                                    <div class="ellipsed-content" [class.loading]="!bill">
                                                                        <btax-payment-status [payment]="payment"></btax-payment-status>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td class="amount numeric">
                                                                <btax-payment-amount [payment]="payment"></btax-payment-amount>
                                                            </td>
                                                            <td class="actions right align-middle">
                                                                <div class="action-buttons">
                                                                    <ng-container *ngTemplateOutlet="paymentPrintReceipt; context: { $implicit: payment }">
                                                                    </ng-container>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td [attr.colspan]="!(viewport.phone$ | async) ? 2 : 1"></td>
                                <td class="single-line right">
                                    <span class="unimportant-text">Total due</span>
                                </td>
                                <td class="single-line numeric">
                                    <ng-container *ngTemplateOutlet="totalDue"></ng-container>
                                </td>
                                <td *ngIf="!(viewport.phone$ | async)"></td>
                                <td class="total-actions actions right single-line">
                                    <app-icon-button
                                        [title]="addToOrRemoveFromCartTitle$ | async"
                                        (click)="toggleAccountInCart()"
                                        [disabled]="!(accountIsPayable$ | async)"
                                        [spinner]="updatingAccountCartStatus$ | async"
                                        [style.font-size]="'24px'"
                                        [style.margin-right]="'-11px'"
                                    >
                                        {{ !(account$ | async) || !(accountInCart$ | async) ? "add_shopping_cart" : "remove_shopping_cart" }}
                                    </app-icon-button>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </app-show-more>
            </ng-template>
        </ng-template>
    </div>
</div>
